/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Collection } from '../models/collection';

/**
 * Collection Controller
 */
@Injectable({
  providedIn: 'root',
})
class CollectionControllerService extends __BaseService {
  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param collectionTypeName collectionTypeName
   * @return OK
   */
  findCollectionByTypeUsingGETResponse(collectionTypeName: string): __Observable<__StrictHttpResponse<Array<Collection>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/webitem/collection/${collectionTypeName}/version`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Collection>>;
      })
    );
  }
  /**
   * @param collectionTypeName collectionTypeName
   * @return OK
   */
  findCollectionByTypeUsingGET(collectionTypeName: string): __Observable<Array<Collection>> {
    return this.findCollectionByTypeUsingGETResponse(collectionTypeName).pipe(
      __map(_r => _r.body as Array<Collection>)
    );
  }

  /**
   * @param params The `CollectionControllerService.AddCollectionUsingPOSTParams` containing the following parameters:
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `collection`: collection
   *
   * @return OK
   */
  addCollectionUsingPOSTResponse(params: CollectionControllerService.AddCollectionUsingPOSTParams): __Observable<__StrictHttpResponse<Collection>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.collection;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/version`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Collection>;
      })
    );
  }
  /**
   * @param params The `CollectionControllerService.AddCollectionUsingPOSTParams` containing the following parameters:
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `collection`: collection
   *
   * @return OK
   */
  addCollectionUsingPOST(params: CollectionControllerService.AddCollectionUsingPOSTParams): __Observable<Collection> {
    return this.addCollectionUsingPOSTResponse(params).pipe(
      __map(_r => _r.body as Collection)
    );
  }

  /**
   * @param params The `CollectionControllerService.GetCollectionUsingGETParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * @return OK
   */
  getCollectionUsingGETResponse(params: CollectionControllerService.GetCollectionUsingGETParams): __Observable<__StrictHttpResponse<Collection>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/version/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Collection>;
      })
    );
  }
  /**
   * @param params The `CollectionControllerService.GetCollectionUsingGETParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * @return OK
   */
  getCollectionUsingGET(params: CollectionControllerService.GetCollectionUsingGETParams): __Observable<Collection> {
    return this.getCollectionUsingGETResponse(params).pipe(
      __map(_r => _r.body as Collection)
    );
  }

  /**
   * @param params The `CollectionControllerService.UpdateCollectionUsingPOSTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `collection`: collection
   *
   * @return OK
   */
  updateCollectionUsingPOSTResponse(params: CollectionControllerService.UpdateCollectionUsingPOSTParams): __Observable<__StrictHttpResponse<Collection>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    __body = params.collection;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/version/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Collection>;
      })
    );
  }
  /**
   * @param params The `CollectionControllerService.UpdateCollectionUsingPOSTParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `collection`: collection
   *
   * @return OK
   */
  updateCollectionUsingPOST(params: CollectionControllerService.UpdateCollectionUsingPOSTParams): __Observable<Collection> {
    return this.updateCollectionUsingPOSTResponse(params).pipe(
      __map(_r => _r.body as Collection)
    );
  }

  /**
   * @param params The `CollectionControllerService.DeleteCollectionUsingDELETEParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `collectionTypeName`: collectionTypeName
   */
  deleteCollectionUsingDELETEResponse(params: CollectionControllerService.DeleteCollectionUsingDELETEParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/version/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `CollectionControllerService.DeleteCollectionUsingDELETEParams` containing the following parameters:
   *
   * - `id`: id
   *
   * - `collectionTypeName`: collectionTypeName
   */
  deleteCollectionUsingDELETE(params: CollectionControllerService.DeleteCollectionUsingDELETEParams): __Observable<null> {
    return this.deleteCollectionUsingDELETEResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module CollectionControllerService {

  /**
   * Parameters for addCollectionUsingPOST
   */
  export interface AddCollectionUsingPOSTParams {

    /**
     * collectionTypeName
     */
    collectionTypeName: string;

    /**
     * collection
     */
    collection: Collection;
  }

  /**
   * Parameters for getCollectionUsingGET
   */
  export interface GetCollectionUsingGETParams {

    /**
     * id
     */
    id: number;

    /**
     * collectionTypeName
     */
    collectionTypeName: string;
  }

  /**
   * Parameters for updateCollectionUsingPOST
   */
  export interface UpdateCollectionUsingPOSTParams {

    /**
     * id
     */
    id: number;

    /**
     * collectionTypeName
     */
    collectionTypeName: string;

    /**
     * collection
     */
    collection: Collection;
  }

  /**
   * Parameters for deleteCollectionUsingDELETE
   */
  export interface DeleteCollectionUsingDELETEParams {

    /**
     * id
     */
    id: number;

    /**
     * collectionTypeName
     */
    collectionTypeName: string;
  }
}

export { CollectionControllerService }
